import React, { useEffect } from 'react'
import { CircularProgress } from '@material-ui/core'
import { Form } from 'react-final-form'
import { Button } from '../../atoms/Button'
import axios from 'axios'
import { useHistory } from 'react-router-dom'
import { FORM_ERROR } from 'final-form'
import { useAuth } from '../../molecules/Auth'
import { PasswordField } from '../../molecules/fields/PasswordField'
import ErrorValidationMessage from '../../molecules/ErrorValidationMessage'
import PublicFooter from '../../organisms/footer/PublicFooter'
import SupportMessage from '../../molecules/SupportMessage'
import * as validations from '../../../utils/validations'

const ChangePassword = () => {
  const history = useHistory()
  const { user, getUser, logout } = useAuth()

  const handleCancel = () => {
    logout().then(() => {
      history.push('/')
    })
  }

  useEffect(() => {
    if (!user?.needs_password_change) {
      history.replace('/formularios')
    }
  }, [user])

  const handleChangePassword = async values => {
    try {
      if (values.password !== values.confirm_password) {
        return { [FORM_ERROR]: 'Las contraseñas no coinciden' }
      }
      await axios.post('/admin/v1/account/change_password', { password: values.password })
      await getUser()
      history.push('/formularios')
      localStorage.setItem('showFormStartMessage', 'true')
    } catch (error) {
      return { [FORM_ERROR]: error.response?.data?.error || 'Error al cambiar la contraseña' }
    }
  }

  return (
    <>
      <div className="flex-1 md:flex items-center justify-center">
        <div className="px-6 pt-8 md:py-16 md:flex items-center justify-center w-full max-w-lg">
          <div className="m-auto w-full">
            <Form onSubmit={handleChangePassword}>
              {({ handleSubmit, submitError, submitting, pristine, values }) => {
                const password = values.password || ''
                const hasLength = password.length >= 8
                const hasUpper = /[A-Z]/.test(password)
                const hasLower = /[a-z]/.test(password)
                const hasNumber = /\d/.test(password)
                const hasSpecial = /[@$!%*?&#]/.test(password)
                const isValid = hasLength && hasUpper && hasLower && hasNumber && hasSpecial

                return (
                  <form
                    onSubmit={handleSubmit}
                    className="bg-white p-6 lg:p-10 shadow-card-login items-center justify-center"
                  >
                    <h2 className="font-bold text-xl mb-6">Cambio de contraseña</h2>
                    <p className="mb-4">Por seguridad, debes cambiar tu contraseña.</p>

                    <PasswordField
                      name="password"
                      label="Nueva contraseña"
                      size="full"
                      errorClassName="hidden"
                      validate={validations.mix(validations.required(), validations.passwordComplexity(' '))}
                    />

                    <PasswordField
                      name="confirm_password"
                      label="Confirmar nueva contraseña"
                      size="full"
                      validate={validations.required()}
                    />

                    <ul className="text-sm mb-4 bg-gray-50 p-3 rounded list-inside mt-4">
                      <li className={hasLength ? 'text-green-600' : 'text-red-500'}>
                        {hasLength ? '✓' : '•'} Mínimo 8 caracteres
                      </li>
                      <li className={hasLower ? 'text-green-600' : 'text-red-500'}>
                        {hasLower ? '✓' : '•'} Al menos una letra minúscula
                      </li>
                      <li className={hasUpper ? 'text-green-600' : 'text-red-500'}>
                        {hasUpper ? '✓' : '•'} Al menos una letra mayúscula
                      </li>
                      <li className={hasNumber ? 'text-green-600' : 'text-red-500'}>
                        {hasNumber ? '✓' : '•'} Al menos un número
                      </li>
                      <li className={hasSpecial ? 'text-green-600' : 'text-red-500'}>
                        {hasSpecial ? '✓' : '•'} Al menos un carácter especial (@, #, &, $, * o !)
                      </li>
                    </ul>

                    {submitError && <ErrorValidationMessage className="max-w-fit mb-6" error={submitError} />}

                    <Button disabled={submitting || !isValid} type="submit" size="full" className="m-auto">
                      {submitting ? <CircularProgress size={24} color="inherit" /> : 'Cambiar contraseña'}
                    </Button>

                    <div className="text-center mt-4">
                      <button
                        type="button"
                        onClick={handleCancel}
                        className="text-gray-500 hover:text-gray-700 text-sm underline"
                      >
                        Cancelar
                      </button>
                    </div>
                  </form>
                )
              }}
            </Form>
            <SupportMessage />
          </div>
        </div>
      </div>
      <PublicFooter />
    </>
  )
}

export default ChangePassword
